import { createEnrichmentIsland } from "@/utils/islands";

const onToggleClick = (event: MouseEvent) => {
    event.preventDefault();

    const target = event.currentTarget as HTMLButtonElement;

    const isExpanded = target.getAttribute('aria-expanded') === 'true';
    target.setAttribute('aria-expanded', String(!isExpanded));
    target.classList.toggle('active', !isExpanded);
};

export default function init() {
    createEnrichmentIsland('[app="expand-toggle"]', (elm: Element) => {
        elm.addEventListener('click', (event: Event) => onToggleClick(event as MouseEvent));
    });
}